import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send } from 'lucide-react';

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/pas-treasury-check/admin/stablecoin/send`;

export const AdminBaseSend = ({ token, onDone }) => {
  const [f, setF] = useState({ token: 'BETH', to: '', amount: '' });
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!window.confirm(`Send ${f.amount} ${f.token} on Base to ${f.to}?`)) return;
    setBusy(true);
    try { const r = await axios.post(URL, { ...f, amount: Number(f.amount) }, { headers: { Authorization: `Bearer ${token}` } }); toast.success(r.data.message); setF({ ...f, amount: '' }); onDone && onDone(); }
    catch (e) { toast.error(e.response?.data?.detail?.toString() || 'Transfer failed'); }
    setBusy(false);
  };
  return (
    <div className="border-t border-slate-700 pt-3 space-y-2" data-testid="admin-base-send">
      <p className="text-sm text-white font-semibold flex items-center gap-2"><Send className="w-4 h-4 text-cyan-400" /> Send from treasury wallet (unrestricted)</p>
      <div className="flex flex-wrap gap-2">
        <select value={f.token} onChange={(e) => setF({ ...f, token: e.target.value })} className="px-3 py-2 bg-slate-950 border border-slate-600 rounded text-white text-sm" data-testid="admin-send-token">
          {['BETH', 'USDC', 'ETH'].map(t => <option key={t} value={t}>{t === 'BETH' ? 'BETH USD' : t}</option>)}
        </select>
        <input placeholder="0x… recipient on Base" value={f.to} onChange={(e) => setF({ ...f, to: e.target.value.trim() })} className="flex-1 min-w-[240px] px-3 py-2 bg-slate-950 border border-slate-600 rounded text-white text-sm font-mono" data-testid="admin-send-to" />
        <input type="number" placeholder="Amount" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} className="w-32 px-3 py-2 bg-slate-950 border border-slate-600 rounded text-white text-sm" data-testid="admin-send-amount" />
        <button disabled={busy || f.to.length !== 42 || !(Number(f.amount) > 0)} onClick={go} className="px-4 py-2 bg-cyan-600 hover:bg-cyan-500 disabled:opacity-40 text-white rounded text-sm font-semibold" data-testid="admin-send-submit">{busy ? 'Sending…' : 'Send'}</button>
      </div>
    </div>
  );
};
